"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaMetropolis = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var SpaceName_1 = require("../../SpaceName");
var SpaceType_1 = require("../../SpaceType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Options_1 = require("../Options");
var LunaMetropolis = (function (_super) {
    __extends(LunaMetropolis, _super);
    function LunaMetropolis() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNA_METROPOLIS,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.SPACE, Tags_1.Tags.EARTH],
            cost: 21,
            metadata: {
                cardNumber: '236',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1).slash().earth(1, { played: Options_1.played }); }).br;
                    b.city().asterix();
                }),
                description: 'Increase your M€ production 1 step for each Earth tag you have, including this. Place a City tile on the RESERVED AREA',
                victoryPoints: 2,
            },
        }) || this;
    }
    ;
    LunaMetropolis.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.getTagCount(Tags_1.Tags.EARTH) + 1, { log: true });
        player.game.addCityTile(player, SpaceName_1.SpaceName.LUNA_METROPOLIS, SpaceType_1.SpaceType.COLONY);
        return undefined;
    };
    LunaMetropolis.prototype.getVictoryPoints = function () {
        return 2;
    };
    return LunaMetropolis;
}(Card_1.Card));
exports.LunaMetropolis = LunaMetropolis;
